import {SystemOptionsStateInterface} from './interfaces/state.interface';

export const SystemOptionsInitialStateConstant: SystemOptionsStateInterface = {
    currencies: []
};